import { render, staticRenderFns } from "./HrResearch.vue?vue&type=template&id=4c2d33dd&"
import script from "./HrResearch.vue?vue&type=script&lang=js&"
export * from "./HrResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports